import { j as m } from "../../../jsx-runtime-C_CB0Y6V.js";
import * as e from "react";
import F, { forwardRef as n } from "react";
import { c as s } from "../../../clsx-OuTLNxxd.js";
import { CaptionText as H } from "../../Typography/caption/index.js";
import "../../Typography/base.js";
import "../../Typography/heading/index.js";
import { Text as $ } from "../../Typography/text/index.js";
import { F as j } from "../../../LabelPairedChevronDownSmBoldIcon-BQLeEB7X.js";
import '../../../assets/index22.css';const y = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 18, viewBox: "0 0 12 18", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "M6.375 3.875v2.25c0 .21-.187.375-.375.375a.37.37 0 0 1-.375-.375v-2.25c0-.187.164-.375.375-.375.188 0 .375.188.375.375m0 9v2.25c0 .21-.187.375-.375.375a.37.37 0 0 1-.375-.375v-2.25c0-.187.164-.375.375-.375.188 0 .375.188.375.375M0 9.5c0-.187.164-.375.375-.375h2.25c.188 0 .375.188.375.375 0 .21-.187.375-.375.375H.375A.37.37 0 0 1 0 9.5m9.375-.375h2.25c.188 0 .375.188.375.375 0 .21-.187.375-.375.375h-2.25A.37.37 0 0 1 9 9.5c0-.187.164-.375.375-.375m.867-3.867c.14.164.14.398 0 .539L8.648 7.39c-.164.14-.398.14-.539 0-.14-.141-.14-.375 0-.54l1.594-1.593c.14-.14.375-.14.54 0m-6.375 6.914-1.594 1.57a.332.332 0 0 1-.515 0 .332.332 0 0 1 0-.515l1.57-1.594c.164-.14.399-.14.54 0 .14.14.14.375 0 .539m-2.11-6.914c.141-.14.376-.14.516 0l1.594 1.594c.14.164.14.398 0 .539-.14.14-.375.14-.539 0l-1.57-1.594c-.164-.14-.164-.375 0-.54m6.891 6.375 1.594 1.594c.14.14.14.375 0 .515-.164.164-.398.164-.539 0l-1.594-1.57c-.14-.164-.14-.399 0-.54.141-.14.375-.14.54 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "141cd38f9a86897059a924cacb9ba552__a" },
      e.createElement("path", { d: "M0 0h12v18H0z" })
    )
  )
), z = n(y), C = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 22, viewBox: "0 0 14 22", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "M7.438 4.188v2.625A.45.45 0 0 1 7 7.25a.43.43 0 0 1-.437-.437V4.188A.45.45 0 0 1 7 3.75a.47.47 0 0 1 .438.438m0 10.5v2.624A.45.45 0 0 1 7 17.75a.43.43 0 0 1-.437-.437v-2.625A.45.45 0 0 1 7 14.25a.47.47 0 0 1 .438.438M0 10.75a.45.45 0 0 1 .438-.437h2.625a.47.47 0 0 1 .437.437.45.45 0 0 1-.437.438H.438A.43.43 0 0 1 0 10.75m10.938-.437h2.624a.47.47 0 0 1 .438.437.45.45 0 0 1-.437.438h-2.626a.43.43 0 0 1-.437-.438.45.45 0 0 1 .438-.437M11.949 5.8c.164.191.164.465 0 .629l-1.86 1.86c-.19.163-.464.163-.628 0-.164-.165-.164-.438 0-.63l1.86-1.86c.163-.163.437-.163.628 0m-7.437 8.066L2.652 15.7a.387.387 0 0 1-.601 0 .387.387 0 0 1 0-.601l1.832-1.86c.191-.164.465-.164.629 0s.164.438 0 .63M2.05 5.801a.43.43 0 0 1 .601 0l1.86 1.86c.164.19.164.464 0 .628s-.438.164-.63 0L2.052 6.43c-.192-.163-.192-.437 0-.628m8.039 7.437 1.86 1.86a.43.43 0 0 1 0 .601c-.192.192-.466.192-.63 0l-1.86-1.832c-.163-.191-.163-.465 0-.629.165-.164.438-.164.63 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "76437a0a987a441088dcd923bbfd8804__a" },
      e.createElement("path", { d: "M0 0h14v22H0z" })
    )
  )
), N = n(C), I = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 24, viewBox: "0 0 16 24", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "m7.469 16.531-6-6c-.313-.281-.313-.75 0-1.062.281-.281.75-.281 1.062 0L8 14.969 13.469 9.5c.281-.312.75-.312 1.062 0a.736.736 0 0 1 0 1.031l-6.031 6a.684.684 0 0 1-1.031 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "fb29c7337ab356cd17023304850033b2__a" },
      e.createElement("path", { d: "M0 0h16v24H0z" })
    )
  )
), D = n(I), S = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 24, viewBox: "0 0 16 24", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "M8.5 4.5v3c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5v-3c0-.25.219-.5.5-.5.25 0 .5.25.5.5m0 12v3c0 .281-.25.5-.5.5a.494.494 0 0 1-.5-.5v-3c0-.25.219-.5.5-.5.25 0 .5.25.5.5M0 12c0-.25.219-.5.5-.5h3c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-3A.494.494 0 0 1 0 12m12.5-.5h3c.25 0 .5.25.5.5 0 .281-.25.5-.5.5h-3a.494.494 0 0 1-.5-.5c0-.25.219-.5.5-.5m1.156-5.156c.188.218.188.531 0 .718l-2.125 2.125c-.219.188-.531.188-.719 0-.187-.187-.187-.5 0-.718l2.126-2.125c.187-.188.5-.188.718 0m-8.5 9.218-2.125 2.094a.442.442 0 0 1-.687 0 .442.442 0 0 1 0-.687l2.094-2.125c.218-.188.53-.188.718 0 .188.187.188.5 0 .719M2.344 6.345a.49.49 0 0 1 .687 0l2.125 2.125c.188.219.188.531 0 .719-.187.187-.5.187-.718 0L2.344 7.062c-.219-.187-.219-.5 0-.718m9.187 8.5 2.125 2.125a.49.49 0 0 1 0 .687c-.219.219-.531.219-.719 0l-2.124-2.093c-.188-.22-.188-.532 0-.72.187-.187.5-.187.718 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "659fd6a08876f5133bb80b6f87808a56__a" },
      e.createElement("path", { d: "M0 0h16v24H0z" })
    )
  )
), T = n(S), V = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 30, viewBox: "0 0 20 30", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "m9.336 21.164-7.5-7.5c-.39-.351-.39-.937 0-1.328.351-.352.937-.352 1.328 0L10 19.21l6.836-6.836c.352-.39.937-.39 1.328 0a.92.92 0 0 1 0 1.29l-7.539 7.5a.856.856 0 0 1-1.29 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "080fa5b1de59c30f7e871bcd5aec65a9__a" },
      e.createElement("path", { d: "M0 0h20v30H0z" })
    )
  )
), X = n(V), k = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 30, viewBox: "0 0 20 30", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "M10.625 6.125v3.75A.64.64 0 0 1 10 10.5a.617.617 0 0 1-.625-.625v-3.75c0-.312.273-.625.625-.625.313 0 .625.313.625.625m0 15v3.75A.64.64 0 0 1 10 25.5a.617.617 0 0 1-.625-.625v-3.75c0-.312.273-.625.625-.625.313 0 .625.313.625.625M0 15.5c0-.312.273-.625.625-.625h3.75c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625H.625A.617.617 0 0 1 0 15.5m15.625-.625h3.75c.313 0 .625.313.625.625a.64.64 0 0 1-.625.625h-3.75A.617.617 0 0 1 15 15.5c0-.312.273-.625.625-.625M17.07 8.43c.235.273.235.664 0 .898l-2.656 2.656c-.273.235-.664.235-.898 0-.235-.234-.235-.625 0-.898l2.656-2.656c.234-.235.625-.235.898 0M6.445 19.953 3.79 22.57a.553.553 0 0 1-.86 0 .553.553 0 0 1 0-.86l2.618-2.655c.273-.235.664-.235.898 0 .235.234.235.625 0 .898M2.93 8.43a.613.613 0 0 1 .86 0l2.655 2.656c.235.273.235.664 0 .898-.234.235-.625.235-.898 0L2.93 9.328c-.274-.234-.274-.625 0-.898m11.484 10.625 2.656 2.656a.613.613 0 0 1 0 .86c-.273.273-.664.273-.898 0l-2.656-2.618c-.235-.273-.235-.664 0-.898.234-.235.625-.235.898 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "6e791c605efb9bd555b16208309f7b5f__a" },
      e.createElement("path", { d: "M0 0h20v30H0z" })
    )
  )
), G = n(k), J = ({ title: l, titleId: t, ...a }, c) => e.createElement(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 36, viewBox: "0 0 24 36", role: "img", ref: c, "aria-labelledby": t, ...a },
  l ? e.createElement("title", { id: t }, l) : null,
  e.createElement(
    "g",
    null,
    e.createElement("path", { d: "m11.203 24.797-9-9c-.469-.422-.469-1.125 0-1.594.422-.422 1.125-.422 1.594 0L12 22.453l8.203-8.203c.422-.469 1.125-.469 1.594 0a1.103 1.103 0 0 1 0 1.547l-9.047 9a1.027 1.027 0 0 1-1.547 0" })
  ),
  e.createElement(
    "defs",
    null,
    e.createElement(
      "clipPath",
      { id: "87be93b11ee36c1c104bfd30e6d30714__a" },
      e.createElement("path", { d: "M0 0h24v36H0z" })
    )
  )
), K = n(J), p = {
  xl: "quill-button__size--xl",
  lg: "quill-button__size--lg",
  md: "quill-button__size--md",
  sm: "quill-button__size--sm"
}, Q = {
  sm: j,
  md: D,
  lg: X,
  xl: K
}, U = {
  sm: z,
  md: N,
  lg: T,
  xl: G
}, W = n(
  ({
    className: l,
    color: t = "coral",
    icon: a,
    children: c,
    isDropdownOpen: h,
    dropdown: v = !1,
    hideChevron: _ = !1,
    selected: x,
    fullWidth: i = !1,
    isLoading: o = !1,
    size: r = "md",
    label: d,
    disabled: u,
    iconPosition: b = "start",
    isOpaque: w,
    variant: M = "primary",
    iconButton: f = !1,
    ...L
  }, R) => {
    const q = `quill__color--${M}-${t}`, g = `quill-icon-button__size--${r}`, B = r === "md" ? "sm" : r === "lg" ? "md" : "xl", E = Q[r], P = U[r], A = w ? "span" : F.Fragment;
    return /* @__PURE__ */ m.jsx(
      A,
      {
        ...w ? {
          className: s(
            "quill-button",
            "quill-button__white-bg-wrapper",
            f ? g : p[r],
            i && "quill-button__full-width"
          )
        } : {},
        children: /* @__PURE__ */ m.jsxs(
          "button",
          {
            className: s(
              "quill-button",
              f ? g : p[r],
              q,
              l,
              i && "quill-button__full-width"
            ),
            disabled: u,
            "data-state": x ? "selected" : "",
            "data-loading": o,
            ref: R,
            ...L,
            children: [
              b === "start" && a && !o && a,
              o && !u && /* @__PURE__ */ m.jsx(
                P,
                {
                  "data-testid": "button-loader",
                  className: "quill-button__loader-icon"
                }
              ),
              c,
              d && !o && /* @__PURE__ */ m.jsx("span", { className: "quill-button-label", children: r === "sm" ? /* @__PURE__ */ m.jsx(H, { color: t, bold: !0, children: d }) : /* @__PURE__ */ m.jsx($, { size: B, bold: !0, color: t, children: d }) }),
              b === "end" && a && !o && a,
              v && !_ && E && !o && /* @__PURE__ */ m.jsx(
                E,
                {
                  "data-state": h ? "open" : "close",
                  className: s(
                    "quill-button__transform",
                    h && "quill-button__transform-rotate"
                  )
                }
              )
            ]
          }
        )
      }
    );
  }
);
W.displayName = "Button";
export {
  W as Button,
  p as ButtonSize,
  W as default,
  U as loaderIcons
};
